import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Reserva } from './paginas/Reserva.jsx';
import { Estado } from './componentes/Estado.jsx';
import { Cabecera } from './componentes/Cabecera.jsx';
import { Pie } from './componentes/Pie.jsx';

// El panel se descarga sólo cuando alguien entra a /panel. La página pública
// es la que abre un cliente desde el celular con datos: no tiene por qué
// bajarse la agenda del dueño para reservar un corte.
const Panel = lazy(() => import('./panel/Panel.jsx'));

// Y el panel de la plataforma, por la misma razón elevada al cuadrado: lo usa
// una sola persona. No tiene por qué estar en el bundle de nadie más.
const Admin = lazy(() => import('./admin/Admin.jsx'));

// El registro vive en el chunk del panel y no en el público: quien se anota
// entra al asistente dos segundos después, así que el bundle que se baja acá
// es el que va a necesitar igual. Y así reusa los campos, los estilos y el
// medidor sin una segunda copia.
const Registro = lazy(() => import('./panel/paginas/Registro.jsx'));

// El paso a paso para instalar la app. Chunk propio y no el del panel: se abre
// desde un mail, en un celular y a veces con mala señal, y son seis pasos para
// leer. No tiene por qué bajarse la agenda del dueño para eso.
const Instalar = lazy(() => import('./paginas/Instalar.jsx'));

// La vuelta de Mercado Pago. Chunk propio: la ve una de cada muchas personas
// —sólo las que pagaron una seña— y no tiene por qué pesar en el bundle con
// el que todos los demás abren la página de reservas.
const Pago = lazy(() => import('./paginas/Pago.jsx'));

/** La raíz sin slug no corresponde a ningún negocio. */
function SinNegocio() {
  return (
    <div className="pantalla">
      <Cabecera negocio={null} />
      <main className="contenido">
        <Estado icono="buscar" titulo="Falta el nombre del negocio">
          <p>
            El link de reservas termina con el nombre del negocio, por ejemplo
            holaturnos.com/barberia-del-centro. Pedíselo a quien te lo compartió.
          </p>
        </Estado>
      </main>
      <Pie />
    </div>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SinNegocio />} />
        {/* Antes de /:slug: ni 'panel' ni 'admin' son nombres de negocios.
            El backend los tiene en su lista de slugs reservados, así que
            tampoco puede aparecer un negocio que se llame así. */}
        <Route
          path="/panel/*"
          element={<Suspense fallback={null}><Panel /></Suspense>}
        />
        <Route
          path="/admin/*"
          element={<Suspense fallback={null}><Admin /></Suspense>}
        />
        <Route
          path="/registro"
          element={<Suspense fallback={null}><Registro /></Suspense>}
        />
        {/* Antes de /:slug, como las de arriba. 'instalar' además está en los
            slugs reservados del backend, así que ningún negocio puede quedarse
            con ese link y descubrir que su página de reservas no abre. */}
        <Route
          path="/instalar"
          element={<Suspense fallback={null}><Instalar /></Suspense>}
        />
        {/* Donde cae la persona al volver de Mercado Pago. Tiene que ser una
            ruta de verdad: sin esto, /{negocio}/pago no coincide con nada y la
            vuelta del checkout termina en el redirect a la raíz. */}
        <Route
          path="/:slug/pago"
          element={<Suspense fallback={null}><Pago /></Suspense>}
        />
        <Route path="/:slug" element={<Reserva />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
